import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SCREEN_SIZE } from '../components/ivy-carousel/screen-size.enum';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class ResizeService {
    private resizeSubject: Subject<SCREEN_SIZE>;

    get onResize$(): Observable<SCREEN_SIZE> {
        return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
    }

    constructor() {
        this.resizeSubject = new Subject();
    }

    onResize(size: SCREEN_SIZE) {
        this.resizeSubject.next(size);
    }
}
